export const enum PendingItemType {
  CONTRACT = 'Contrato',
  PROFORMA = 'Proforma',
  BILL = 'Factura',
  EXTENSION = 'Ampliación'
}
